export default __webpack_public_path__ + "static/media/802.60e5f1a0.gif";